import { render, staticRenderFns } from "./CreateAntiPhishingModal.vue?vue&type=template&id=1d87768a&scoped=true"
import script from "./CreateAntiPhishingModal.vue?vue&type=script&lang=js"
export * from "./CreateAntiPhishingModal.vue?vue&type=script&lang=js"
import style0 from "./CreateAntiPhishingModal.vue?vue&type=style&index=0&id=1d87768a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d87768a",
  null
  
)

export default component.exports